import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../components/Checkbox';
import { useCarsSearchExtension } from './CarsSearchExtensionContext';
import { withPageContext } from '../../utils';

const CarsSearchExtension = ({ tab, trackEvent }) => {
    const { tabsStatus, setTabsStatus } = useCarsSearchExtension();
    const { t } = useTranslation();
    const show = tabsStatus[tab].showCheckbox;

    const trackingAction = 'searcher_flights';

    useEffect(() => {
        if (show && !tabsStatus[tab].isLoaded) {
            trackEvent({
                action: trackingAction,
                label: `car_rental_deals_check_onload_tab:${tab}_pag:home`,
            });

            const newTabsStatus = { ...tabsStatus, [tab]: { ...tabsStatus[tab], isLoaded: true } };
            setTabsStatus(newTabsStatus);
        }
    }, []);

    const handleCheckboxChange = () => {
        const newTabsStatus = {
            ...tabsStatus,
            [tab]: { ...tabsStatus[tab], isEnabled: !tabsStatus[tab].isEnabled },
        };

        let label;

        if (newTabsStatus[tab].isEnabled) {
            label = `car_rental_deals_check_selected_tab:${tab}_pag:home`;
        } else {
            label = `car_rental_deals_uncheck_selected_tab:${tab}_pag:home`;
        }

        trackEvent({
            action: trackingAction,
            label,
        });

        setTabsStatus(newTabsStatus);
    };

    return show ? (
        <div className='odf-space-inner-bottom-s'>
            <Checkbox
                checked={tabsStatus[tab].isEnabled}
                id={`${tab}-cars-search-extension`}
                onChange={handleCheckboxChange}
            >
                {t('carsSearchExtension.checkbox.label')}
            </Checkbox>
        </div>
    ) : null;
};

CarsSearchExtension.propTypes = {
    tab: PropTypes.oneOf(['dp', 'flights', 'hotels']).isRequired,
};

const PageContextCarsSearchExtension = withPageContext(CarsSearchExtension);

export { PageContextCarsSearchExtension as CarsSearchExtension };
